// @flow strict
import React from 'react';
import styles from './Header.module.scss';
import { useSiteMetadata } from '../../../hooks';

const Header = () => {
  const { title } = useSiteMetadata();

  return (
    <header className={styles['header']} id={'gatsby-focus-wrapper'}>
      <div className={styles['header__wrapper']}>
        <a className={styles['header__site-title']} href="/">
          <span className={styles['site-title']}>{title}</span>
        </a>
      </div>
    </header>);
};

export default Header;